import { type FC } from 'react'
import { observer } from 'mobx-react-lite'
import { type ConversationsHistoryMessagesStore } from 'widgets/ContactsDetails/ui/ContactsConversationsHistory'
import { ConversationsHistoryMessages } from './ConversationsHistoryMessages'

type IContactsConversationsHistoryProps = {
  store: ConversationsHistoryMessagesStore
  isModalView: boolean
}

export const ContactsConversationsHistory: FC<IContactsConversationsHistoryProps> = observer(
  ({ store, isModalView }) => {
    const contact = store.contact

    if (!contact) return null

    return <ConversationsHistoryMessages isModalView={isModalView} store={store} />
  }
)
